import React from 'react';
import '../styles/Modal.css';

const CancelSubscriptionModal = ({ onClose, onConfirm }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Cancel Subscription</h2>
        <p>Are you sure you want to cancel your subscription? You will continue to have access until the end of your current billing period.</p>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            Keep Subscription
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            Cancel Subscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;